import { Button } from "antd";
import { useExport } from "./hooks/useExport";

export const Bulk1098 = () => {
  const { isLoading, onExport } = useExport();

  return (
    <Button
      className="pa-0"
      type="link"
      size="small"
      disabled={isLoading}
      onClick={onExport}
    >
      Bobby's Tax 1098
    </Button>
  );
};
